/**
 * Sticky Header
 * Adds a class to header on scroll
 */
// import magnificPopup from '../vendors/jquery-magnificpopup';
import organicTabs from '../vendors/organic-tab';
import slick from '../vendors/slick.min';
import Owl from '../vendors/owl.carousel.min';
import Masonry from '../vendors/masonry.min';
import GSAP from '../vendors/gsap.min';
import ScrollTrigger from '../vendors/ScrollTrigger.min';
import SplitText from '../vendors/SplitText.min';
import magnificPopup from '../vendors/jquery-magnificpopup';

// clock;
function updateClock(city, timezone) {
	const element = document.getElementById(`${city}-time`);
	if (element) {
		const now = new Date();
		const options = {
			timeZone: timezone,
			hour12: true,
			hour: 'numeric',
			minute: '2-digit'
		};
		const localTime = now.toLocaleTimeString('en-US', options);
		element.textContent = localTime;
	}
}
function updateClocks() {
	updateClock('atx', 'America/Chicago'); // Austin, Texas
	updateClock('nyc', 'America/New_York'); // New York
	updateClock('tyo', 'Asia/Tokyo'); // Tokyo
}

// Update clocks every second
setInterval( updateClocks, 1000 );

// Initial update
updateClocks();
jQuery.noConflict();
if ( jQuery( window ).width() > 1003 ) {
	jQuery( document ).on( 'scroll', function() {
		if ( jQuery( document ).scrollTop() > 100 ) {
			jQuery( 'header, body' ).addClass( 'shrink' );
		} else {
			jQuery( 'header, body' ).removeClass( 'shrink' );
		}
	} );
}
if ( jQuery( window ).width() < 1003 ) {
	jQuery( document ).on( 'scroll', function() {
		if ( jQuery( document ).scrollTop() > 30 ) {
			jQuery( 'header, body' ).addClass( 'shrink' );
		} else {
			jQuery( 'header, body' ).removeClass( 'shrink' );
		}
	} );
}
/**
 * Document Ready Function
 * Triggered when document get's ready
 */

// jQuery('img').on('load', function(){
// 	alert("loaded");
// 	console.log("loaded");
// 	// jQuery(this).addClass('loaded');
// });

// jQuery(".wp-image-10").on('load', function () {
//         console.log("loaded");
//     }
// );
jQuery( document ).ready( function() {
	jQuery( '.popup-btn' ).click( function() {
		jQuery( 'body' ).toggleClass( 'no-overflow' );
	} );
} );

// script for header up and down
if ( jQuery( window ).width() > 1003 ) {
	let lastScrollTop = 0,
		delta = 15;
	jQuery( window ).scroll( function( event ) {
		const st = jQuery( this ).scrollTop();
		if ( Math.abs( lastScrollTop - st ) <= delta ) {
			return;
		}
		if ( st > lastScrollTop && lastScrollTop > 0 ) {
			jQuery( '.header-section-inner' ).addClass( 'nav-up' );
			jQuery( '.header-section-inner' ).removeClass( 'nav-down' );
			jQuery( '.header-section-inner' ).removeClass( 'stay-show-header' );
		} else {
			jQuery( '.header-section-inner' ).removeClass( 'nav-up' );
			jQuery( '.header-section-inner' ).addClass( 'nav-down' );
		}
		lastScrollTop = st;
	} );
}

// header-popup

jQuery( document ).on( 'click', function( e ) {
	if ( ! jQuery( e.target ).closest( '.header-popup' ).length ) {
		jQuery( '.header-popup' ).removeClass( 'show-popup' );
		jQuery( '.popup-btn' ).removeClass( 'active' );
		jQuery( 'body' ).removeClass( 'no-overflow' );
	}
} );

jQuery( document ).ready( function() {
	jQuery( '.ajax-department' ).on( 'click', function() {
		jQuery( 'body' ).find( '.learn-more' ).addClass( 'clicked' );
		jQuery( 'html, body' ).animate( { scrollTop: jQuery( '#ajax-category-image' ).offset().top } );
	} );
} );

jQuery( function() {
	// jQuery( '.ajax-department' ).on( 'click', function() {
	// 	jQuery( 'body' ).find( '.learn-more' ).addClass( 'clicked' );
	// 	jQuery( 'body' ).find( '.learn-more' ).trigger( 'click' );
	// } );

	jQuery( '.animate-text' ).owlCarousel( {
	   items: 1,
		loop: false,
		nav: false,
		dots: false,
		autoplay: true,
		animateOut: 'slideOutUp',
		animateIn: 'slideInUp',
		mouseDrag: false,
		touchDrag: false,
		autoplayTimeout: 800,
	} );

	if ( jQuery( window ).width() > 1003 ) {
		jQuery( '.header-section' ).on( 'mouseenter', function() {
			jQuery( this ).find( '.header-section-inner' ).addClass( 'stay-show-header' );
		} );
	}

	// Operating system window body get class

	function isWindows() {
		return navigator.platform.toUpperCase().indexOf( 'WIN' ) > -1;
	}

	// Check if the operating system is Windows and add the class if true
	if ( isWindows() ) {
		jQuery( 'body' ).addClass( 'style-for-window' );
	}
	// Function to detect if the operating system is macOS
	function isMacOS() {
		return navigator.platform.toUpperCase().indexOf( 'MAC' ) > -1;
	}

	// Check if the operating system is macOS and add the class if true
	if ( isMacOS() ) {
		jQuery( 'body' ).addClass( 'style-for-mac' );
	}
	jQuery( '.popup-btn' ).on( 'click focus', function( e ) {
		e.stopPropagation();
		const headerPopup = jQuery( '.header-popup' );
		const popupBtn = jQuery( this );

		// Toggle the 'show-popup' class on header-popup
		headerPopup.toggleClass( 'show-popup' );

		// Toggle the 'active' class on popup-btn
		popupBtn.toggleClass( 'active' );

		// If the header-popup has the 'show-popup' class after toggling, set a focusout event
		if ( headerPopup.hasClass( 'show-popup' ) ) {
			jQuery( document ).on( 'focusin.popup', function( event ) {
				if ( ! headerPopup.is( event.target ) && headerPopup.has( event.target ).length === 0 ) {
					headerPopup.removeClass( 'show-popup' );
					popupBtn.removeClass( 'active' );
					jQuery( document ).off( 'focusin.popup' );
				}
			} );
		}
	} ).on( 'focusout', function() {
		jQuery( '.header-popup' ).removeClass( 'show-popup' );
		jQuery( this ).removeClass( 'active' );
	} );

	gsap.registerPlugin( SplitText, ScrollTrigger );

	let animationTriggered = false;

	if ( jQuery( window ).width() > 1003 ) {
		if ( jQuery( '.intro-ctn .intro-text' ).length > 0 ) {
			const doText = () => {
				if ( ! animationTriggered ) {
					animationTriggered = true; // Set the flag to true so the animation won't trigger again

					jQuery( '.intro-ctn .intro-text' ).css( {
						opacity: 1,
						visibility: 'visible',
					} );

					const text = new SplitText( '.intro-ctn .intro-text', {
						types: 'lines',
						linesClass: 'lineChild',
					} );
					const mask = new SplitText( '.intro-ctn .intro-text', {
						types: 'lines',
						linesClass: 'lineParent',
					} );
					const textAnim = gsap.fromTo(
						'.lineChild',
						{ yPercent: 200 },
						{
							yPercent: 0,
							duration: 0.8,
							stagger: 0.08,
						}
					);

					const totalDelay = mask.lines.length * 0.3;
					console.log( totalDelay );

					gsap.to( '.intro-btn', {
						opacity: 1,
						duration: 0.5,
						ease: 'linear',
						delay: totalDelay,
					} );
				}
			};

			if ( jQuery( '.intro-ctn' ).length > 0 ) {
				ScrollTrigger.create( {
					trigger: '.intro-ctn',
					start: 'top 50%',
					onEnter: () => {
						doText();
					},
				} );
			}
		}
	}

	if ( jQuery( window ).width() < 1004 ) {
		jQuery( '.intro-ctn .intro-text' ).css( {
			opacity: 1,
			visibility: 'visible',
		} );

		const text = new SplitText( '.intro-ctn .intro-text', {
			types: 'lines',
			linesClass: 'lineChild',
		} );

		const mask = new SplitText( '.intro-ctn .intro-text', {
			types: 'lines',
			linesClass: 'lineParent',
		} );
	}

	if ( jQuery( window ).width() > 747 ) {
		jQuery( '.gallery-ctn' ).masonry( {
			itemSelector: '.gallery-item-col',
			columnWidth: '.gallery-item-col',
			gutter: 20,
		} );
	}
	/**
	 * Script for gravity form label swap
	 */

	jQuery(
		'input[type="text"],input[type="email"],input[type="tel"],textarea'
	).each( function() {
		jQuery( this ).parent().parent( '.gfield' ).addClass( 'label-down' );
	} );

	jQuery( 'input[type="text"],input[type="email"],input[type="tel"]' ).each(
		function() {
			jQuery( this ).on( 'focus', function() {
				jQuery( this ).parent().parent( '.gfield' ).addClass( 'active' );
			} );

			jQuery( this ).on( 'blur', function() {
				if ( jQuery( this ).val().length == 0 ) {
					jQuery( this )
						.parent()
						.parent( '.gfield' )
						.removeClass( 'active' );
				}
			} );

			if ( jQuery( this ).val() != '' ) {
				jQuery( this ).parent( '.css' ).addClass( 'active' );
			}
		}
	);

	jQuery( 'textarea' ).each( function() {
		jQuery( this ).on( 'focus', function() {
			jQuery( this ).parent().parent( '.gfield' ).addClass( 'active' );
		} );

		jQuery( this ).on( 'blur', function() {
			if ( jQuery( this ).val().length == 0 ) {
				jQuery( this ).parent().parent( '.gfield' ).removeClass( 'active' );
			}
		} );

		if ( jQuery( this ).val() != '' ) {
			jQuery( this ).parent( '.css' ).addClass( 'active' );
		}
	} );

	// Perfect Wp-images

	const extLink = jQuery( 'body a' ).filter( function() {
		return this.hostname && this.hostname !== location.hostname;
	} );
	extLink.each( function() {
		jQuery( this ).attr( 'target', '_blank' );
		jQuery( this ).addClass( 'external-link' );
	} );

	// jQuery( window ).load( function() {
	// 	if ( jQuery( document ).scrollTop() > 0 ) {
	// 		const $header_height = jQuery( 'header' ).outerHeight();
	// 		jQuery( 'body' ).css( 'padding-top', $header_height + 'px' );
	// 	} else {
	// 		const $header_height = jQuery( 'header' ).outerHeight();
	// 		jQuery( 'body' ).css( 'padding-top', $header_height + 'px' );
	// 	}
	// } );

	/**
	 * Toggle menu for mobile
	 */
	// accessible sub menu
	jQuery( '.menu-item-has-children > a' )
		.focus( function() {
			jQuery( this ).siblings( '.sub-menu' ).addClass( 'focused' );
		} )
		.blur( function() {
			jQuery( this ).siblings( '.sub-menu' ).removeClass( 'focused' );
		} );

	jQuery( '.menu-btn' ).on( 'click', function() {
		jQuery( this ).toggleClass( 'active' );
		jQuery( '.nav-overlay' ).toggleClass( 'open' );
		jQuery( 'html, body' ).toggleClass( 'no-overflow' );
		jQuery( '.header-nav ul li.active' ).removeClass( 'active' );
		jQuery( '.header-nav ul.sub-menu' ).slideUp();
	} );
	jQuery.noConflict();

	/**
	 * Add span tag to multi-level accordion menu for mobile menus
	 */
	jQuery( 'li' ).each( function() {
		if ( jQuery( this ).hasClass( 'menu-item-has-children' ) ) {
			jQuery( this )
				.find( 'a:first' )
				.after( '<span class="submenu-icon"></span>' );
		}
	} );
	/**
	 * Slide Up/Down internal sub-menu when mobile menu arrow clicked
	 */
	jQuery( '.header-nav .submenu-icon' ).on( 'click', function() {
		const link = jQuery( this );
		const closestUl = link.closest( 'ul' );
		const parallelActiveLinks = closestUl.find( '.active' );
		const closestLi = link.closest( 'li' );
		const linkStatus = closestLi.hasClass( 'active' );
		let count = 0;

		closestUl.find( 'ul' ).slideUp( function() {
			if ( ++count === closestUl.find( 'ul' ).length ) {
				parallelActiveLinks.removeClass( 'active' );
			}
		} );

		if ( ! linkStatus ) {
			closestLi.children( 'ul' ).slideDown();
			closestLi.addClass( 'active' );
		}
	} );

	// // text-ara

	setTimeout( () => {
		autosize();
		function autosize() {
			const text = jQuery( '.gfield--type-textarea textarea' );
			text.each( function() {
				jQuery( this ).attr( 'rows', 1 );
				resize( jQuery( this ) );
			} );
			text.on( 'input', function() {
				resize( jQuery( this ) );
			} );
			function resize( $text ) {
				$text.css( 'height', 'auto' );
				$text.css( 'height', $text[ 0 ].scrollHeight + 'px' );
			}
		}
	}, 2000 );

	// popup

	jQuery( '.with-popup .play-button' ).magnificPopup( {
		type: 'inline',
		mainClass: 'mfp-fade',
		callbacks: {
			open() {
				// Play video on open:
				jQuery( this.content ).find( 'video' )[ 0 ].play();
			},
			close() {
				// Reset video on close:
				jQuery( this.content ).find( 'video' )[ 0 ].load();
			},
		},
	} );

	// jQuery( '.careers-tabs' ).organicTabs( {
	// 	speed: 200,
	// } );

	if ( jQuery( window ).width() < 1004 ) {
		jQuery( '.select-dropdown__button' ).on( 'click', function() {
			const dropdown = jQuery( this ).closest( '.select-dropdown' );
			dropdown.find( '.select-dropdown__button' ).toggleClass( 'is-button-opened' );
			dropdown.find( '.select-dropdown__list' ).toggleClass( 'is-active-dropdown' );
		} );
		// jQuery( '.dropdown-list-title' ).on( 'click', function() {
		// 	const dropdown = jQuery( this ).closest( '.select-dropdown' );
		// 	dropdown.find( '.select-dropdown__button' ).toggleClass( 'is-button-opened' );
		// 	dropdown.find( '.select-dropdown__list' ).toggleClass( 'is-active-dropdown' );
		// } );

		jQuery( '.inner-title' ).on( 'click', function() {
			const buttonText = jQuery( this ).text();
			const buttonTabNo = jQuery( this ).parent().find( '.tab-no' ).text();
			jQuery( this ).parents( '.select-dropdown' ).find( '.select-dropdown__button .inner-title' ).text( buttonText );
			jQuery( this ).parents( '.select-dropdown' ).find( '.select-dropdown__button .tab-no' ).text( buttonTabNo );
			const dropdown = jQuery( this ).closest( '.select-dropdown' );
			dropdown.find( '.select-dropdown__button' ).removeClass( 'is-button-opened' );
			dropdown.find( '.select-dropdown__list' ).removeClass( 'is-active-dropdown' );
		} );
	}

	// 	// Style Variations
	// 	 const modeOptions = jQuery( 'input[name="mode"]' );
	// 	const body = jQuery( 'body' );

	// 	// Function to update the mode based on the selected radio button
	// 	function updateMode() {
	// 		const selectedMode = modeOptions.filter( ':checked' ).attr( 'id' );

	// 		body.removeClass( 'dark-mode light-dark-mode high-contrast-mode' );

	// 		if ( selectedMode === 'dark-mode' ) {
	// 			body.addClass( 'dark-mode' );
	// 			localStorage.setItem( 'mode', 'dark-mode' );
	// 		} else if ( selectedMode === 'light-dark-mode' ) {
	// 			body.addClass( 'light-dark-mode' );
	// 			localStorage.setItem( 'mode', 'light-dark-mode' );
	// 		} else if ( selectedMode === 'high-contrast-mode' ) {
	// 			body.addClass( 'high-contrast-mode' );
	// 			localStorage.setItem( 'mode', 'high-contrast-mode' );
	// 		} else {
	// 			// Default to light mode if no radio button is selected
	// 			body.addClass( 'light-mode' );
	// 			localStorage.setItem( 'mode', 'light-mode' );
	// 		}
	// 	}

	// 	// Check local storage for user preference
	// 	const userPreference = localStorage.getItem( 'mode' );
	// 	if ( userPreference ) {
	// 		modeOptions.filter( `#${ userPreference }` ).prop( 'checked', true );
	// 		updateMode();
	// 	}

	// 	// Handle radio button change events
	// 	modeOptions.change( updateMode );

	// gallery slider
	if ( jQuery( window ).width() < 1004 ) {
		jQuery( '.gallery-ctn' ).slick( {
			slidesToShow: 1,
			slidesToScroll: 1,
			arrows: false,
			dots: false,
			variableWidth: true,
			infinite: false,

		} );
	}
	//

	if ( jQuery( window ).width() < 1004 ) {
		jQuery( '.popup-btn' ).click( function() {
			// Add class 'active' to the body
			jQuery( 'body' ).toggleClass( 'active-menu' );
		} );
	}

	// jQuery( '.call-heading ' ).slick( {
	// 	slidesToShow: 1,
	// 	slidesToScroll: 1,
	// 	autoplay: true,
	// 	autoplaySpeed: 0,
	// 	speed: 10000,
	// 	pauseOnHover: false,
	// 	cssEase: 'linear',
	// 	variableWidth: true,
	// 	adaptiveHeight: true,
	// 	arrows: false,
	// } );

	//team-members
	jQuery( '.member-tab' ).on( 'mouseover', function() {
		jQuery( '.member-image' ).removeClass( 'active' );
		jQuery( '.member-tab' ).removeClass( 'active_location' );
		jQuery( this ).addClass( 'active_location' );
		jQuery( '.member-image[data-id="' + jQuery( this ).attr( 'id' ) + '"]' ).addClass( 'active' );
	} );

	jQuery( '.location__pin' ).on( 'mouseover', function() {
		jQuery( '.location-single' ).removeClass( 'active' );
		jQuery( '.location__pin' ).removeClass( 'active_location' );
		jQuery( this ).addClass( 'active_location' );
		jQuery( '.location-single[data-id="' + jQuery( this ).attr( 'id' ) + '"]' ).addClass( 'active' );
	} );

	// featured work
	let maxWidth = 0;

	// Loop through each span.title
	jQuery( 'span.title' ).each( function() {
		// Get the width of the current span.title
		const currentWidth = jQuery( this ).width();

		// Update maxWidth if the current width is larger
		if ( currentWidth > maxWidth ) {
			maxWidth = currentWidth;
		}
	} );

	// Apply the maximum width to all span.title elements
	jQuery( 'span.title' ).width( maxWidth );

	// team-images
	if ( jQuery( window ).width() > 1003 ) {
		if ( jQuery( '.team-images' ).length > 0 ) {
			const teamImages = document.querySelector( '.team-images' );
			// Define the window dimensions
			const windowWidth = window.innerWidth / 15;
			const windowHeight = window.innerHeight / 10;
			// Add event listener to the '.team-images' container
			teamImages.addEventListener( 'mousemove', ( e ) => {
			// Loop through each '.team-single-image' element
				teamImages.querySelectorAll( '.team-single-image' ).forEach( ( bg ) => {
				// Calculate the mouse position relative to the window dimensions
					const mouseX = e.clientX / windowWidth;
					const mouseY = e.clientY / windowHeight;
					// Apply the transformation to each '.team-single-image' element
					bg.style.transform = `translate(-${ mouseX * 5 }px, -${ mouseY * 5 }px)`;
				} );
			} );
		}
		if ( jQuery( '.team-block' ).length > 0 ) {
			// Function to set up custom cursor for a swiper-container
			function setupCustomCursor( slider ) {
				const cursor = document.querySelector( '.cursor-move' );
				const cursorDot = cursor.querySelector( '.cursor-dot' );
				function moveCursor( event ) {
					cursor.style.transform = `translate3d(calc(${ event.clientX }px - 50vw), calc(${ event.clientY }px - 50vh), 0)`;
				}
				// To reset the transition after the movement is done
				function resetTransition() {
					cursor.style.transition = 'none';
				}
				// Attach event listeners
				document.addEventListener( 'mousemove', moveCursor );
				document.addEventListener( 'transitionend', resetTransition );
				slider.addEventListener( 'mousemove', ( event ) => {
					moveCursor( event );
				} );
				slider.addEventListener( 'pointermove', ( event ) => {
					moveCursor( event );
				} );
				slider.addEventListener( 'mouseenter', () => {
					cursorDot.classList.add( 'show' );
				} );
				slider.addEventListener( 'mouseleave', () => {
					cursorDot.classList.remove( 'show' );
				} );
				slider.addEventListener( 'pointerdown', () => {
					cursorDot.classList.add( 'active' );
				} );
				slider.addEventListener( 'pointerup', () => {
					cursorDot.classList.remove( 'active' );
				} );
			}
			// Get all swiper-containers and apply custom cursor logic to each
			const swiperContainers =
            document.querySelectorAll( '.team-block' );
			swiperContainers.forEach( ( slider ) => {
				setupCustomCursor( slider );
			} );
		}
	}
	if ( jQuery( window ).width() < 1004 ) {
		jQuery( '.team-images' ).slick( {
			slidesToShow: 1,
			slidesToScroll: 1,
			arrows: false,
			dots: false,
			infinite: false,
			fade: true,
			autoHeight: true,
			autoplay: true,
			autoplaySpeed: 2000,
			cssEase: 'ease-in-out',
		} );
	}
} );

function adjustSpanWidths() {
	// Iterate over each span within hero-team-tabs
	jQuery( '.hero-team-tabs span' ).each( function() {
		// Get the outer width of the span
		const currentWidth = jQuery( this ).outerWidth();

		// Add 15 pixels to the width
		const newWidth = currentWidth + 15;

		// Assign the new width to the span
		jQuery( this ).css( 'width', newWidth + 'px' );
	} );
}

jQuery( document ).ready( function() {
	// Call the function on document ready
	setTimeout( () => {
		adjustSpanWidths();
	}, 1000 );
} );

jQuery( window ).resize( function() {
	// Call the function on window resize
	adjustSpanWidths();
} );

function adjustDptWidths() {
	// Iterate over each span within hero-team-tabs
	jQuery( '.dropdown-list-title .inner-title' ).each( function() {
		// Get the outer width of the span
		const currentWidth = jQuery( this ).outerWidth();

		// Add 15 pixels to the width
		const newWidth = currentWidth + 15;

		// Assign the new width to the span
		jQuery( this ).css( 'min-width', newWidth + 'px' );
	} );
}

jQuery( document ).ready( function() {
	// Call the function on document ready
	setTimeout( () => {
		adjustDptWidths();
	}, 500 );
} );

jQuery( window ).resize( function() {
	// Call the function on window resize
	adjustDptWidths();
} );
